export function stringifyEnum(originalEnum: string): string {
  return originalEnum.match(/[A-Z]+[^A-Z]*|[^A-Z]+/g).join(' ')
}
